// extracted by mini-css-extract-plugin
module.exports = {"container":"Gz","disabled":"Hz","bgBlack":"Iz","content":"Jz","countdown":"Kz","topCaption":"Lz","topHeading":"Mz","heading":"Nz","copy":"Oz"};